import * as React from "react";
import { useGenericState } from "src/Library/UseGenericState";

const useExpandable = (defaultHeight: number) => {
  const initialState = {
    collapsed: true,
    expandable: true,
    height: defaultHeight as string | number,
  };
  const [state, setState] = useGenericState(initialState);
  const ref = React.useRef() as React.MutableRefObject<HTMLInputElement>;

  const expand = () => setState({ collapsed: false });
  const collapse = () => setState({ collapsed: true });

  const decorator = (child: React.ReactElement): React.ReactNode => {
    return React.cloneElement(child, {
      ...child.props,
      ref,
      style: {
        ...child.props.style,
        maxHeight: state.height,
      }
    });
  };

  // React.useEffect(() => {
  //   setState({ collapsed: false });
  // }, []);

  React.useEffect(() => {
    if (ref?.current?.scrollHeight || ref?.current?.clientHeight) {
      if (ref?.current?.scrollHeight <= defaultHeight) {
        setState({ collapsed: false })
      } else {
        if (!state.collapsed) {
          setState({ collapsed: true })
        }
      }
      if (ref?.current?.scrollHeight >= ref?.current?.clientHeight) {
        setState({ expandable: true });
      } else {
        if (!state.collapsed) {
          setState({ expandable: false });
          // if(ref?.current?.scrollHeight) {
          //   setState({ collapsed: false })
          // }
        }
      }
    }
  }, [ref?.current?.scrollHeight]);

  React.useEffect(() => {
    if (state.collapsed && state.height !== defaultHeight) {
      setState({ height: defaultHeight });
    }
    if (!state.collapsed && state.height !== '') {
      setState({ height: '' });
    }
  }, [state.collapsed]);

  React.useEffect(() => {
    if (ref?.current?.scrollHeight === ref?.current?.clientHeight) {
      setState({ collapsed: true })
    }
  }, [state.expandable, ref?.current]);

  return {
    ref,
    vector: ref?.current,
    decorator,
    collapsed: state.collapsed,
    expand,
    collapse,
    expandable: state.expandable, //isTallerThanDefault,
    height: state.height,
  };
};

export default useExpandable;
